/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const getFetchModule = require('@utils/get_fetch/getFetchModule');
const CategoriesService = require('./categoriesService');

const categoriesModule = angular
    .module('enervee_utils.categories', [
        commonModule.name,
        consumersModule.name,
        getFetchModule.name,
    ])
    .provider('CategoriesService', CategoriesService);

module.exports = categoriesModule;